export const GET_LAT_LONG_GET_REQUEST = 'GET_LAT_LONG_GET_REQUEST';
export const GET_LAT_LONG_GET_SUCCESS = 'GET_LAT_LONG_GET_SUCCESS';
